module.exports = __webpack_public_path__ + "img/9.1f765b22.png";